module.exports = __webpack_public_path__ + "img/twic.0e1f072d.svg";